import React from 'react'

export const CERRAR = <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
<title>cerrar</title>
<g id="Capa_2" data-name="Capa 2">
  <g id="capa_2-2" data-name="capa 2">
    <g>
      <path d="M9.5,19A9.5,9.5,0,1,1,19,9.5,9.511,9.511,0,0,1,9.5,19ZM9.5.76A8.74,8.74,0,1,0,18.24,9.5,8.75,8.75,0,0,0,9.5.76Z" fill="#ffff"/>
      <path d="M10.207,9.5l4.647-4.646a.5.5,0,0,0-.707-.707L9.5,8.793,4.854,4.147a.5.5,0,0,0-.707.707L8.793,9.5,4.147,14.147a.5.5,0,0,0,.707.707L9.5,10.207l4.647,4.647a.5.5,0,0,0,.707-.707Z" fill="#ffff"/>
    </g>
  </g>
</g>
</svg>
;